export enum ToursDashboardTypes {
  FETCH_TOURS_START = 'FETCH_TOURS_START',
  FETCH_TOURS_SUCCESS = 'FETCH_TOURS_SUCCESS',
  FETCH_TOURS_FAILURE = 'FETCH_TOURS_FAILURE',
  UPDATE_TOUR_START = 'UPDATE_TOUR_START',
  UPDATE_TOUR_SUCCESS = 'UPDATE_TOUR_SUCCESS',
  UPDATE_TOUR_FAILURE = 'UPDATE_TOUR_FAILURE',
}
